function getHost() {
  return typeof window !== 'undefined' ? window.location.host : '';
}

export default getHost;
